<div class="form-wrapper" style="position: relative;">
  <div class="row">
    <div class="col-md-3">
      <section class="contact-info-box">
        <div>
          <h3>CVAP Contact Information</h3>
          <p>
            <strong>Office:</strong><br />
            Toll free - 1 866 660-3888
          </p>
          <p>
            <strong>Office:</strong><br />
            Lower Mainland - 604 660-3888
          </p>
          <p>
            <strong>Mailing:</strong><br />
            PO Box 5550 Station Terminal,<br />Vancouver, B.C. V6B 1H1
          </p>
          <p>
            <strong>Email:</strong><br />
            <a [href]="'mailto: ' + cvapEmail">{{cvapEmail}}</a>
          </p>
        </div>
      </section>
    </div>
    <div class="col-md-9">
      <h1>Application Cancelled</h1>
      <p>You have successfully cancelled the application.</p>
      <p>The Crime Victim Assistance Program (CVAP) is committed to ensuring access to CVAP services. Please contact us if you need information to assist you in completing the application submission process. <em>Refer to the CVAP Contact Information available on this page.</em></p>
      <h2>Other Application Forms</h2>
      <ul>
        <li class="nav-item">
          <a tabindex="2" routerLink="/victim-application" title="Home">Victim Application</a>
        </li>
        <li class="nav-item">
          <a tabindex="2" routerLink="/witness-application" title="Home">Witness Application</a>
        </li>
        <li class="nav-item">
          <a tabindex="2" routerLink="/ifm-application">Immediate Family Member Application</a>
        </li>
      </ul>
      <p><a routerLink="/">Click here for more info on the Crime Victim Assistance Program</a></p>
    </div>
  </div>
</div>